// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes spinAround-data-v-597938b6{from{transform:rotate(0deg)}to{transform:rotate(359deg)}}.c-page-top[data-v-597938b6]{position:fixed;right:10px;bottom:10px;z-index:1000}.c-page-top .button[data-v-597938b6]{cursor:pointer}.c-page-top .button .icon[data-v-597938b6]{transform:rotate(-90deg) scale(0.8)}\n", ""]);
// Exports
module.exports = exports;
